<article id="table-zoom" class="stages_description"><table #spacer></table></article>
